import { render, staticRenderFns } from "./documentHistory.vue?vue&type=template&id=26d62023&scoped=true&"
import script from "./documentHistory.vue?vue&type=script&lang=js&"
export * from "./documentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d62023",
  null
  
)

export default component.exports